import React from 'react';
import OrderIndex from '../../components/order-index/OrderIndex';
import ColumnsSelector from '../../store/column/ColumnsSelector';

export default () => {
  return <OrderIndex columnSelector={ColumnsSelector.selectAdminOrderColumns} showColumnEdit />;
};
